import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import Toggle from '@jetbrains/ring-ui/components/toggle/toggle';
import { PageTitle } from '@common/page-layout/page-title';
import { useFeatureFlag, useUpdateFeatureFlagMutation } from '@common/queries/feature-flags';
import { BasicSelectableTable } from '@common/tables/basic-selectable-table';
import styles from './feature-flags.css';
export function FeatureFlagsPage() {
    var _a;
    const { data: featureFlags, isLoading } = useFeatureFlag();
    const { mutate } = useUpdateFeatureFlagMutation();
    const handleToggleChange = useCallback((id, e) => {
        const newValue = e.target.checked;
        mutate({ id, enabled: newValue });
    }, [mutate]);
    const columns = useMemo(() => [
        {
            id: 'actionButtons',
            title: 'Enabled',
            getValue: (flag) => getFeatureToggle(flag, (e) => handleToggleChange(flag.id, e))
        },
        {
            id: 'id',
            title: 'Feature Flag ID'
        },
        {
            id: 'description',
            title: 'Description',
            className: styles.descriptionColumn
        }
    ], [handleToggleChange]);
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Feature Flags" }), _jsx(BasicSelectableTable, { data: (_a = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.items.sort((a, b) => a.id.localeCompare(b.id))) !== null && _a !== void 0 ? _a : [], loading: isLoading, selectable: false, columns: columns, renderEmpty: () => (isLoading ? 'Loading...' : 'No feature flags found') })] }));
}
export default FeatureFlagsPage;
function getFeatureToggle(flag, onChange) {
    return _jsx(Toggle, { checked: flag.enabled, onChange: onChange });
}
